import React from "react";
import "../CSS/ContactUs.css";


const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94
      1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059
      -.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371
      -.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01
      -.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198
      2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719
      2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 2C6.477 2 2 6.477 2
      12c0 1.89.525 3.66 1.438 5.168L2 22l4.978-1.301A9.963 9.963 0 0 0 12 22c5.523 0 10-4.477
      10-10S17.523 2 12 2z"/>
  </svg>
);

const IconEmail = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0
      2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);

const ContactUs = () => (
  <div className="contact-page">
    <div className="contact-card">

      {/* Identity */}
      <div className="contact-name-row">
        <img src="/sejiwa-logo-2.png" alt="Sejiwa Logo" className="contact-logo" />
        <h1 className="contact-name">Sejiwa</h1>
      </div>

      {/* About */}
      <p className="contact-about">
        Sebarang pertanyaan atau cadangan, anda boleh menghubungi kami di bawah.
      </p>

      {/* Divider */}
      <div className="contact-pill-divider">
        <span>Hubungi Kami</span>
      </div>

      {/* Action Buttons */}
      <div className="contact-actions">
        <a
          href="https://wa.me/601112345678"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-btn btn-whatsapp"
        >
          <IconWhatsApp />
          WhatsApp
        </a>

        <a
          href="mailto:sejiwamy@gmail.com"
          className="contact-btn btn-email"
        >
          <IconEmail />
          Email
        </a>
      </div>

    </div>
  </div>
);

export default ContactUs;
